<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          <a >Grinder Reborer</a>
        </li>
      </ol>
      <div class="row">
        <div class="col-md-12">
           <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
              />
            </div>
          </div>
        </div>

        <div class="col-md-2 ">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllUsers(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>
       
        <div class="col-md-2" v-if="$can('Create','ServicePartner::Grinder Reborer') || $can('Delete','ServicePartner::Grinder Reborer')">
          <div class="form-group">
            <button  class="btn btn-primary submitbtn btn-raised" @click="$router.push('/allGrinderReborer')">Active List</button>
          </div>
        </div>
        
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="button" class="btn btn-default">New KYC Request&nbsp;<span class="badge"> {{NewVerificationCount}}</span></button>
          <button type="button" class="btn btn-default">Total Grinder Reborers&nbsp;<span class="badge"> {{VerifiedCount}}</span></button>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Reborer Plus Grinder ID</th>
                    <th>Reborer Plus Grinder Name</th>
                    <th>Address</th>
                    <th>PIN Code</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Total Points Accumulated</th>
                    <th>Point Balance</th>
                    <th>Total Points Redeemed</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr class="odd gradeX"> -->
                  <tr
                    v-for="(item, index) in users_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'editGrinderReborer',
                          params: { partner_id: item.UserCode },
                        }"
                        >{{ item.UserCode }}</router-link
                      >
                    </td>
                    <td>{{ item.first_name | removeNull}} {{item.last_name | removeNull}}</td>
                    <td>{{ item.AddressLine1 | removeNull }} {{ item.AddressLine2 | removeNull }}</td>
                    <td>{{ item.ZIP | removeNull}}</td>
                    <td>{{ item.State | removeNull }}</td>
                    <td>{{ item.selectedCity | removeNull}}</td>
                    <td>{{ item.TotalPoints | removeNull }}</td>
                    <td>{{ item.TotalPoints - item.RedeemptionPoints  | setnullZero }}</td>
                    <td>{{ item.RedeemptionPoints | setnullZero }}</td>
                    <td>
                      <a v-on:click="approveRequest(item.entity_id)"  v-if="!parseInt(item.is_verified)"><i class="glyphicon glyphicon-ok"></i> Verify</a>
                      <a v-on:click="showKYCRequest(item.UserCode)"  v-if="item.ApprovalStatus == 'Requestd'"><i class="glyphicon glyphicon glyphicon-check"></i>&nbsp; KYC</a>
                      <a href="#" @click="DeactivateEmployee(item.id)">{{item.active=== "1" ? "Active": "InActive"}}</a>
                      </td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllUsers"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                v-model="refreshPageState"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="externalScript"></div> -->
   
    <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close button" @click="showModal=false">
                  <span aria-hidden="false">X</span>
                </button>
                <h4 class="modal-title">KYC Approval Request ( {{ KYCData.UserCode  }} )</h4>
              </div>
              <div class="modal-body">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                  <tr><td class="align-left">Driving Licence No </td> <td class="align-left ">: {{KYCData.DrivingLicenseNo}}</td></tr>
                  <tr><td class="align-left">Aadhar Card No </td><td class="align-left">: {{KYCData.AadharCardNo}}</td></tr>
                  <tr><td class="align-left">PAN No </td><td class="align-left">: {{KYCData.PANNo}}</td></tr>
                  <tr><td class="align-left">Date Of Birth No </td><td class="align-left">: {{KYCData.DateOfBirth}}</td></tr>
                  <tr><td class="align-left">Size Of Workshop </td><td class="align-left">: {{KYCData.SizeOfWorkshop}}</td></tr>
                  <tr><td class="align-left">Service Per Month </td><td class="align-left">: {{KYCData.ServicePerMonth}}</td></tr>
                  <tr><td class="align-left">Gender </td><td class="align-left">: {{KYCData.Gender}}</td></tr>
                  <tr><td class="align-left">Year Of Experience </td><td class="align-left">: {{KYCData.YearOfExperience}}</td></tr>
                  <tr><td class="align-left">EnginesOverhauled</td><td class="align-left">: {{KYCData.EnginesOverhauled}}</td></tr>
                  <tr><td class="align-left">GSTN</td><td class="align-left">: {{KYCData.GSTN}}</td></tr>
                </table>
                </div>
                
              </div>
              <div class="modal-footer">
                <button @click="varifyKYCRequest" class="btn btn-primary">Approve</button>
                <button @click="showModal=false" class="btn btn-cancle">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import commonServices from '../../../services/common-services';
export default {
  name: 'AllGrinderReborerDeleted',
  data() {
    return {
      refreshPageState:1,
      KYCData:'',
      showModal: false,
      uploadFile: '',
      users_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message:'',
      NewVerificationCount:0,
      VerifiedCount:0,
      SuccessMessage:'',
      ErrorMessage:''
    };
  },
  components: {
    Paginate,
    vSelect,
  },

  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
     DeactivateEmployee(id){
      let params = {}
      params ="id="+id
       commonServices
        .delete('kspgAPI/BrandEmployee', params)
        .then((response) => {
            this.SuccessMessage = response.data.message;
            if (response.data.status) {
              this.getAllUsers(this.refreshPageState);
              this.SuccessMessage = response.data.Messaage
            }
          },
          (error) => {
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => (this.SuccessMessage = false), 5000);   
        setTimeout(() => (this.ErrorMessage = false), 5000);
    },
     approveRequest(entity_id){
      let data = {};
      data['entity_id'] = entity_id;
      commonServices.put('kspgAPI/Partners/approve',data)
      .then((responce) => {
            this.SuccessMessage = responce.data.message;
            if (responce.data.status) {
              this.getAllUsers(this.refreshPageState);
            }
          },
          (error) => {
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => (this.SuccessMessage = false), 5000);   
        setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    showKYCRequest(userCode){
      let loader = this.$loading.show();
      this.skyloStart();
      this.showModal =true;
       let data = {};
      data['userCode'] = userCode;
      commonServices
        .get('kspgAPI/Partners/kyc', data)
        .then((response) => {
          const {
            data
          } = response.data;
          this.KYCData = data;
         
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 1000)
    },
    varifyKYCRequest(userCode){
      let data = {};
      data['userCode'] = this.KYCData.UserCode;
      commonServices.put('kspgAPI/Partners/kyc',data)
      .then((responce) => {
            this.SuccessMessage = responce.data.message;
            if (responce.data.status) {
              this.showModal =false;
              this.getAllUsers(this.refreshPageState);
            }
          },
          (error) => {
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => (this.SuccessMessage = false), 5000);   
        setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
      params['active'] = "0";
      return params;
    },
    getAllUsers(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/ReborerPlusGrinder/list', params)
        .then((response) => {
          const {
            users_data,
            totalItems,
            currentPage,
            TotalPage,
            NewVerificationCount,
            VerifiedCount
          } = response.data;
          this.users_data = users_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.NewVerificationCount = NewVerificationCount
          this.VerifiedCount =  VerifiedCount
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 1000)
    },
    handleFileUpload() {
      this.uploadFile = this.$refs.file.files[0];
      this.submitFile();
    },
    submitFile() {
      let loader = this.$loading.show();
      let formData = new FormData();
      formData.append('reborerPlusGrinder', this.uploadFile);
      formData.append('partnerType', 'ReborerPlusGrinder');
      
      commonServices
        .post_upload_file('kspgAPI/Partners/upload', formData)
        .then(
          (responce) => {
            this.SuccessMessage = responce.data.message;
            if (responce.data.status) {
              
            }
          },
          (error) => {
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          this.errors.push(e);
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => {loader.hide()}, 2000)
        setTimeout(() => (this.SuccessMessage = false), 5000);   
        setTimeout(() => (this.ErrorMessage = false), 5000);
    },
  },
  computed: {
    download_template(){
      return commonServices.asset_url('assets/doc/ReborerPlusGrinder.csv');
    }
  },
  created() {
    // this.firstCallData;
  },
  mounted() {
    this.getAllUsers(1);
  },
   filters: {
    removeNull(data) {
      if (!data) {
        return '';
      }
      return data;
    },
    setnullZero(data) {
      if (!data) {
        return '0';
      }
      return data;
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.close  {
  color: #000 !important;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.align-left {
  text-align: left !important;
  padding-left:10px;
}
</style>
